import {
  type OfferV11,
  OfferV1OfferTypeEnum,
} from '@redteclab/api/clients/bully'

export const productAccessorGetSaeOffer = ({
  offers,
}: {
  offers: OfferV11[] | undefined
}): OfferV11 | undefined => {
  return offers?.find((offer) => offer.offerType === OfferV1OfferTypeEnum.Sae)
}
